import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { FaqType } from '@appTypes/faqType';
import { Actions, actions } from '@redux/modules/faq';
import { TypedEpic } from './types';

export const fetchDocumentEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_FAQ),
    withLatestFrom(state$) as unknown as OperatorFunction<Action<any>, ActionType<typeof actions.getFaq.request>[]>,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<FaqType[]>(ApiType.apimNafNoApi, {
          signal,
          url: ApiPaths[ApiType.apimNafNoApi].faq,
        }),
      ).pipe(
        map((response) => actions.getFaq.success(response.data)),
        catchError((err) => of(actions.getFaq.failure(toReduxError(err, 'Could not get document')))),
      ),
    ),
  );

export const epics: TypedEpic[] = [fetchDocumentEpic];
